export const sampleEncounters = [
  {
    id: 'sample-1',
    date: '05/23/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective:
      'Patient has associated nausea and vomiting with the abdominal pain.',

    objective:
      'Neck: supple, no lymphadenopathy or thyromegaly\n' +
      'No carotid bruits appreciated\n' +
      'Heart RRR w/o murmurs or gallops',

    assessmentPlan:
      'Patient education provided\n' +
      'Small frequent sips of fluids, advance as tolerated',

    vitals: {
      bp: '123',
      temp: '97',
      hr: '80',
      rr: '20',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnoses: [
      {
        code: 'A04.7',
        description: 'C. Diff colitis'
      },
      {
        code: 'A09',
        description: 'Infectious gastroenteritis and colitis, unspecified'
      }
    ],

    // --------------------------------------------
    // PRESCRIPTION
    // --------------------------------------------
    prescription: {
      medications: [
        {
          id: 1,
          name: 'Montelukast',
          dosage: '10 mg',
          directions: '1-0-0',
          quantity: '20',
          refill: '1'
        },
        {
          id: 2,
          name: 'Telekast',
          dosage: '10 mg',
          directions: '0-0-1',
          quantity: '20',
          refill: '1'
        }
      ],

      comments:
        'Take medications as directed and follow up if symptoms persist.'
    },

    // --------------------------------------------
    // LAB ORDERS
    // --------------------------------------------
    labOrder: {
      labOrder: [
        'CBC',
        'Comprehensive Metabolic Panel',
        'C-Reactive Protein (CRP)'
      ],

      diagnosis: [
        {
          code: 'R10.9',
          description: 'Abdominal pain, unspecified'
        },
        {
          code: 'A09',
          description: 'Infectious gastroenteritis and colitis, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // IMAGING ORDERS
    // --------------------------------------------
    imagingOrder: {
      imagingOrder: [
        'XR of the LS spine to r/o fracture or osteoarthritis',
        'MRI of the Lumbar spine to r/o sciatica',
        'Continue to observe for persistence of symptoms'
      ],

      diagnosis: [
        {
          code: 'I73.9',
          description: 'Peripheral vascular disease'
        },
        {
          code: 'G44.209',
          description: 'Tension headache'
        },
        {
          code: 'M54.50',
          description: 'Low back pain, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // PHYSICIAN ORDERS
    // --------------------------------------------
    physicianOrder: {
      physicianOrder: [
        'Clear liquids, advance as tolerated',
        'Lab tests ordered',
        'Information on gastroenteritis given to patient',
        'Maintain adequate hydration',
        'Follow up if abdominal pain persists'
      ],

      diagnosis: [
        {
          code: 'A37.90',
          description: 'Pertussis'
        },
        {
          code: 'A41.9',
          description: 'Sepsis'
        }
      ]
    },

    status: 'signed',
    signedBy: 'Dr. Charles'
  },

  {
    id: 'sample-2',
    date: '05/22/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Fever and body pain for the past two days with mild fatigue.',

    objective: 'Patient alert and oriented.\n' + 'Chest clear on auscultation.',

    assessmentPlan: 'Encouraged adequate hydration.',

    vitals: {
      bp: '118',
      temp: '99.2',
      hr: '86',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnoses: [
      {
        code: 'R50.9',
        description: 'Fever, unspecified'
      }
    ],

    // --------------------------------------------
    // PRESCRIPTION
    // --------------------------------------------
    prescription: {
      medications: [
        {
          id: 1,
          name: 'Montelukast',
          dosage: '10 mg',
          directions: '1-0-0',
          quantity: '20',
          refill: '1'
        },
        {
          id: 2,
          name: 'Telekast',
          dosage: '10 mg',
          directions: '0-0-1',
          quantity: '20',
          refill: '1'
        }
      ],

      comments:
        'Take medications as directed and follow up if symptoms persist.'
    },

    // --------------------------------------------
    // LAB ORDERS
    // --------------------------------------------
    labOrder: {
      orders: [
        'CBC',
        'Comprehensive Metabolic Panel',
        'C-Reactive Protein (CRP)'
      ],

      diagnosis: [
        {
          code: 'R10.9',
          description: 'Abdominal pain, unspecified'
        },
        {
          code: 'A09',
          description: 'Infectious gastroenteritis and colitis, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // IMAGING ORDERS
    // --------------------------------------------
    imagingOrder: {
      orders: [
        'XR of the LS spine to r/o fracture or osteoarthritis',
        'MRI of the Lumbar spine to r/o sciatica',
        'Continue to observe for persistence of symptoms'
      ],

      diagnosis: [
        {
          code: 'I73.9',
          description: 'Peripheral vascular disease'
        },
        {
          code: 'G44.209',
          description: 'Tension headache'
        },
        {
          code: 'M54.50',
          description: 'Low back pain, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // PHYSICIAN ORDERS
    // --------------------------------------------
    physicianOrder: {
      orders: [
        'Clear liquids, advance as tolerated',
        'Lab tests ordered',
        'Information on gastroenteritis given to patient',
        'Maintain adequate hydration',
        'Follow up if abdominal pain persists'
      ],

      diagnosis: [
        {
          code: 'A37.90',
          description: 'Pertussis'
        },
        {
          code: 'A41.9',
          description: 'Sepsis'
        }
      ]
    },

    status: 'signed',
    signedBy: 'Dr. Alice William'
  },

  {
    id: 'sample-3',
    date: '05/21/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient presents to the medical clinic with severe headache.',

    objective:
      'No focal neurological deficit.\n' + 'Pupils equal and reactive.',

    assessmentPlan: 'Hydration advised.\n' + 'Monitor symptoms.',

    vitals: {
      bp: '120',
      temp: '98',
      hr: '78',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnoses: [
      {
        code: 'R51.9',
        description: 'Headache, unspecified'
      }
    ],

    // --------------------------------------------
    // PRESCRIPTION
    // --------------------------------------------
    prescription: {
      medications: [
        {
          id: 1,
          name: 'Montelukast',
          dosage: '10 mg',
          directions: '1-0-0',
          quantity: '20',
          refill: '1'
        },
        {
          id: 2,
          name: 'Telekast',
          dosage: '10 mg',
          directions: '0-0-1',
          quantity: '20',
          refill: '1'
        }
      ],

      comments:
        'Take medications as directed and follow up if symptoms persist.'
    },

    // --------------------------------------------
    // LAB ORDERS
    // --------------------------------------------
    labOrder: {
      orders: [
        'CBC',
        'Comprehensive Metabolic Panel',
        'C-Reactive Protein (CRP)'
      ],

      diagnosis: [
        {
          code: 'R10.9',
          description: 'Abdominal pain, unspecified'
        },
        {
          code: 'A09',
          description: 'Infectious gastroenteritis and colitis, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // IMAGING ORDERS
    // --------------------------------------------
    imagingOrder: {
      orders: [
        'XR of the LS spine to r/o fracture or osteoarthritis',
        'MRI of the Lumbar spine to r/o sciatica',
        'Continue to observe for persistence of symptoms'
      ],

      diagnosis: [
        {
          code: 'I73.9',
          description: 'Peripheral vascular disease'
        },
        {
          code: 'G44.209',
          description: 'Tension headache'
        },
        {
          code: 'M54.50',
          description: 'Low back pain, unspecified'
        }
      ]
    },

    // --------------------------------------------
    // PHYSICIAN ORDERS
    // --------------------------------------------
    physicianOrder: {
      orders: [
        'Clear liquids, advance as tolerated',
        'Lab tests ordered',
        'Information on gastroenteritis given to patient',
        'Maintain adequate hydration',
        'Follow up if abdominal pain persists'
      ],

      diagnosis: [
        {
          code: 'A37.90',
          description: 'Pertussis'
        },
        {
          code: 'A41.9',
          description: 'Sepsis'
        }
      ]
    },

    status: 'signed',
    signedBy: 'Dr. Charles'
  },

  {
    id: 'sample-4',
    date: '05/20/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient reports persistent dry cough and throat irritation.',

    objective:
      'Chest clear bilaterally.\n' + 'No wheezing or respiratory distress.',

    assessmentPlan: 'Increase oral fluids.\n' + 'Monitor cough symptoms.',

    vitals: {
      bp: '116',
      temp: '98.4',
      hr: '82',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnoses: [
      {
        code: 'R05.9',
        description: 'Cough, unspecified'
      }
    ],

    prescription: {
      medications: [
        {
          id: 1,
          name: 'Cetirizine',
          dosage: '10',
          directions: '0-0-1',
          quantity: '10',
          refill: '0'
        }
      ],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Jennifer Lee'
  },

  {
    id: 'sample-5',
    date: '05/19/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient complains of lower back pain after prolonged sitting.',

    objective: 'Mild lumbar tenderness noted.\n' + 'Range of motion preserved.',

    assessmentPlan:
      'Avoid prolonged sitting.\n' + 'Back stretching exercises advised.',

    vitals: {
      bp: '121',
      temp: '97.8',
      hr: '76',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'M54.50',
        description: 'Low back pain, unspecified'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Henry Low'
  },

  {
    id: 'sample-6',
    date: '05/18/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective:
      'Patient reports nasal congestion and seasonal allergy symptoms.',

    objective:
      'Mild nasal congestion noted.\n' + 'Lungs clear to auscultation.',

    assessmentPlan:
      'Avoid known allergens.\n' + 'Continue allergy medication as needed.',

    vitals: {
      bp: '119',
      temp: '98.1',
      hr: '79',
      rr: '17',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'J30.9',
        description: 'Allergic rhinitis, unspecified'
      }
    ],

    prescription: {
      medications: [
        {
          id: 1,
          name: 'Loratadine',
          dosage: '10',
          directions: '1-0-0',
          quantity: '15',
          refill: '0'
        }
      ],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Alice William'
  },

  {
    id: 'sample-7',
    date: '05/17/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective:
      'Patient reports dizziness and generalized fatigue since morning.',

    objective:
      'Patient alert and oriented.\n' + 'No focal neurological deficits.',

    assessmentPlan:
      'Maintain adequate hydration.\n' + 'Monitor blood pressure.',

    vitals: {
      bp: '110',
      temp: '98',
      hr: '74',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'R42',
        description: 'Dizziness and giddiness'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Charles'
  },

  {
    id: 'sample-8',
    date: '05/16/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient complains of sore throat and difficulty swallowing.',

    objective: 'Mild pharyngeal erythema present.\n' + 'No tonsillar exudate.',

    assessmentPlan:
      'Warm salt water gargles advised.\n' + 'Increase fluid intake.',

    vitals: {
      bp: '117',
      temp: '99',
      hr: '83',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'J02.9',
        description: 'Acute pharyngitis, unspecified'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Jennifer Lee'
  },

  {
    id: 'sample-9',
    date: '05/15/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient reports mild abdominal discomfort after meals.',

    objective:
      'Abdomen soft and non-tender.\n' + 'Normal bowel sounds present.',

    assessmentPlan:
      'Avoid spicy foods.\n' + 'Small frequent meals recommended.',

    vitals: {
      bp: '122',
      temp: '98.2',
      hr: '80',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'R10.9',
        description: 'Unspecified abdominal pain'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Henry Low'
  },

  {
    id: 'sample-10',
    date: '05/14/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective:
      'Patient presents with migraine headache associated with nausea.',

    objective:
      'Patient conscious and oriented.\n' + 'No neurological deficit noted.',

    assessmentPlan:
      'Rest in a quiet environment.\n' + 'Maintain adequate hydration.',

    vitals: {
      bp: '124',
      temp: '97.9',
      hr: '81',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'G43.909',
        description: 'Migraine, unspecified'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Charles'
  },

  {
    id: 'sample-11',
    date: '05/13/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient reports mild ear pain since yesterday.',

    objective: 'Mild erythema of external ear canal.\n' + 'No discharge noted.',

    assessmentPlan: 'Keep ear dry.\n' + 'Return if pain or fever increases.',

    vitals: {
      bp: '118',
      temp: '98.8',
      hr: '79',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'H92.09',
        description: 'Otalgia, unspecified ear'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Alice William'
  },

  {
    id: 'sample-12',
    date: '05/12/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective:
      'Patient reports intermittent shortness of breath during exercise.',

    objective: 'Chest expansion normal.\n' + 'No wheezing currently.',

    assessmentPlan:
      'Avoid strenuous exercise temporarily.\n' +
      'Monitor respiratory symptoms.',

    vitals: {
      bp: '120',
      temp: '98',
      hr: '84',
      rr: '20',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'R06.02',
        description: 'Shortness of breath'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Henry Low'
  },

  {
    id: 'sample-13',
    date: '05/11/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient reports itchy red skin rash over both arms.',

    objective:
      'Scattered erythematous rash noted.\n' +
      'No signs of secondary infection.',

    assessmentPlan:
      'Avoid suspected irritants.\n' + 'Keep affected area clean and dry.',

    vitals: {
      bp: '116',
      temp: '98.1',
      hr: '77',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'R21',
        description: 'Rash and other nonspecific skin eruption'
      }
    ],

    prescription: {
      medications: [
        {
          id: 1,
          name: 'Cetirizine',
          dosage: '10',
          directions: '0-0-1',
          quantity: '10',
          refill: '0'
        }
      ],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Jennifer Lee'
  },

  {
    id: 'sample-14',
    date: '05/10/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient presents for routine follow-up and medication review.',

    objective: 'Patient clinically stable.\n' + 'No acute complaints noted.',

    assessmentPlan:
      'Continue current treatment plan.\n' + 'Follow up as scheduled.',

    vitals: {
      bp: '119',
      temp: '98',
      hr: '76',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'Z09',
        description: 'Follow-up examination after treatment'
      }
    ],

    prescription: {
      medications: [],
      comments: 'Continue current medications.'
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Charles'
  },

  {
    id: 'sample-15',
    date: '05/09/2026',

    patientName: 'Willow, Gwen Marry',
    patientInfo: '3/06/2006 (20) yrs',

    subjective: 'Patient presents for routine general health examination.',

    objective:
      'Patient alert and oriented.\n' +
      'Heart and lungs normal on examination.',

    assessmentPlan:
      'Continue healthy diet and regular physical activity.\n' +
      'Routine follow-up recommended.',

    vitals: {
      bp: '117',
      temp: '98.2',
      hr: '75',
      rr: '18',
      wt: '60',
      ht: '6.1',
      bmi: '8.14'
    },

    diagnosis: [
      {
        code: 'Z00.00',
        description:
          'General adult medical examination without abnormal findings'
      }
    ],

    prescription: {
      medications: [],
      comments: ''
    },

    labOrder: null,
    imagingOrder: null,
    physicianOrder: null,

    status: 'signed',
    signedBy: 'Dr. Alice William'
  }
];